import { ModalTomaMuestras } from '@app/core/components/modal-toma-muestras/modal-toma-muestras.component';
import { ModalNoConformidad } from '@app/core/components/modal-no-conformidad/modal-no-conformidad.component';
import { SocketsService } from '@app/core/services/sockets.service';
import { CoreModule } from '@app/core/core.module';
import { ControlCommunicationService } from '@app/form-builder/services/control-communication.service';
import { FormBuilderComponent } from '@app/form-builder/form-builder.component';
import { FormBuilderModule } from '@app/form-builder/form-builder.module';
import { NgModule, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {DatePipe} from '@angular/common'
import { NgSelectModule } from '@ng-select/ng-select';

// Used to create fake backend
//import { fakeBackendProvider } from '@app/core/helpers';

import { AppComponent } from '@app/app.component';
import { AppRoutingModule } from '@app/app-routing.module';

import { NgbdTypeaheadHttpDone } from "@app/core/components/typeahead-done";

import { ConnectionServiceModule } from 'ng-connection-service';

import { JwtInterceptor, ErrorInterceptor, appInitializer, ResponseInterceptor } from './core/helpers';
import { AuthenticationService } from "@app/core/services";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AlertComponent } from '@app/core/components/alert';
import { FooterComponent } from '@app/core/components/footer';
import { HomeComponent } from '@app/features/home';
import { LoginComponent } from "@app/features/login";
import { ForgotPasswordComponent } from "@app/features/forgot-password";
import { ForgotPasswordConfirmationComponent } from "@app/features/forgot-password-confirmation";
import { ResetPasswordComponent } from "@app/features/reset-password";
import { DashboardItemComponent } from "@app/core/components/dashboard-item";
import { ModalChangePassword } from "@app/core/components/change-password";
import { ModalChangeProfileImage } from "@app/core/components/change-imageProfile"
import { SettingsComponent } from "@app/features/settings";

import { ModalContract } from "@app/core/components/modal-contract";
import { ContractMexico, ContractCanada, ContractEurope, ContractUSA } from '@app/core/components/contracts/V5'

import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

import { NgxUploaderModule } from 'ngx-uploader';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer'

import { ModalChangeReviewer } from "@app/core/components/modal-changeReviewer";
import { ModalChangeInspector } from "@app/core/components/modal-changeInspector";
import { ModalChangeDictator } from "@app/core/components/modal-changeDictator";
import { ModalInstructions } from "@app/core/components/modal-instructions";
import { ModalPreview } from "@app/core/components/modal-preview";
import { ModalSelectCustomer } from '@app/core/components/modal-selectCustomer';
import { ModalChangeReviewerSubstances } from '@app/core/components/modal-changeReviewerSubstances';
import { ModalNcsDocuments } from '@app/core/components/modal-ncs-documents'
import { ModalSubstancesReview } from '@app/core/components/modal-substance-review'
import { ModalPreviewUpdateFiles } from '@app/core/components/modal-preview-update-files'
import { ModalUploadCertificateUE } from '@app/core/components/modal-upload-certificate-ue'

import { 
    ModalConfirmAutofocus, 
    ModalSign, 
    ModalApprove, 
    ModalComplete, 
    ModalDelete, 
    ModalApproveInspection, 
    ModalDenyInspection, 
    ModalUploadOfflineData, 
    ModalApproveEvaluation, 
    ModalDenyEvaluation, 
    ModalApproveSubstances, 
    ModalDenyComments, 
    ModalConfirmGenerateCertificate, 
    ModalConfirmUpdateLaboratory,
    ModalUserActions,
    ModalRestorePassword,
    ModalInformGeneratingReport,
    ModalApproveInspectionNotAnnounced,
    ModalApproveEvaluationNotAnnounced,
    ModalConfirmCancelCustomer,
    ModalCancelRecord,
    ModalReactivateCustomer,
    ModalOrganicSurface,
} from "@app/core/components/modal-confirm";

import {
    ModalNewAccompanyingDocument,
    ModalDeleteAccompanyingDocument,
    ModalSignAccompanyingDocument,
    ModalValidateAccompanyingDocument,
    ModalUploadAttachmentAccompanyingDocument,
} from '@app/core/components/modals-accompanying-documents'

registerLocaleData(localeEs, 'es');

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        FormBuilderModule,
        FormsModule,
        HttpClientModule,
        AppRoutingModule,
        NgbModule,
        NgxUploaderModule,
        NgxDocViewerModule,
        FontAwesomeModule,
        CoreModule,
        NgxExtendedPdfViewerModule,
        BrowserAnimationsModule,
        ConnectionServiceModule,
        NgSelectModule,
    ],
    declarations: [
        AppComponent,
        AlertComponent,
        HomeComponent,
        LoginComponent,
        FooterComponent,
        DashboardItemComponent,
        ForgotPasswordComponent,
        ForgotPasswordConfirmationComponent,
        ResetPasswordComponent,
        ModalConfirmAutofocus,
        SettingsComponent,
        NgbdTypeaheadHttpDone,
        ModalChangePassword,
        ModalChangeProfileImage,
        ModalSign,
        ModalApprove,
        ModalComplete,
        ModalContract,
        ModalDelete,
        ModalApproveInspection,
        ModalDenyInspection,
        ModalDenyComments,
        ModalUploadOfflineData,
        ModalApproveEvaluation,
        ModalDenyEvaluation,
        ModalApproveSubstances,
        ModalInstructions,
        ModalSelectCustomer,
        ModalConfirmGenerateCertificate,
        ModalConfirmUpdateLaboratory,
        ModalUserActions,
        ModalRestorePassword,
        ModalApproveInspectionNotAnnounced,
        ModalApproveEvaluationNotAnnounced,
        ModalCancelRecord,
        ModalConfirmCancelCustomer,
        ModalReactivateCustomer,
        ModalOrganicSurface,
        // Modal Contracts Start
        ContractMexico,
        ContractCanada,
        ContractEurope,
        ContractUSA,
        // Modal Contracts End
        ModalChangeReviewer,
        ModalChangeInspector,
        ModalChangeDictator,
        ModalChangeReviewerSubstances,
        ModalPreview,
        ModalNoConformidad,
        ModalTomaMuestras,
        ModalInformGeneratingReport,
        ModalNcsDocuments,
        ModalSubstancesReview,
        ModalPreviewUpdateFiles,
        ModalUploadCertificateUE,
        // Modals Accompanying Documents
        ModalNewAccompanyingDocument,
        ModalDeleteAccompanyingDocument,
        ModalSignAccompanyingDocument,
        ModalValidateAccompanyingDocument,
        ModalUploadAttachmentAccompanyingDocument,
    ],
    exports: [
        NgbdTypeaheadHttpDone,
    ],
    providers: [
        { provide: APP_INITIALIZER, useFactory: appInitializer, multi: true, deps: [AuthenticationService] },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true },
        { provide: LOCALE_ID, useValue: 'es' },
        { provide: DatePipe },
        FormBuilderComponent,
        ControlCommunicationService,
        SocketsService
        // Provider used to create fake backend
        //fakeBackendProvider
    ],
    bootstrap: [AppComponent]
})
export class AppModule { };
